import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

export interface FormSectionHeaderProps {
  index: number;
  label: string;
}

// Numbered section header for multi-step-looking forms inside a modal (Create
// User, Create Payer, etc.) — a small teal circle + label + a divider line
// filling the rest of the row. Pairs with grouping fields into 2-3 column
// rows instead of stacking every field full-width.
const FormSectionHeader: React.FC<FormSectionHeaderProps> = ({ index, label }) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#2F7E8E',
        color: '#ffffff',
        fontSize: 12,
        fontWeight: 700,
        flexShrink: 0,
      }}
    >
      {index}
    </Box>
    <Typography fontWeight={700} sx={{ fontSize: 14, whiteSpace: 'nowrap' }}>
      {label}
    </Typography>
    <Divider sx={{ flex: 1 }} />
  </Stack>
);

export default FormSectionHeader;
